import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { AppraisalMap } from './index';

const map = {
  view_more_reviews: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.ACTION_VIEW_MORE_REVIEWS
  ),
  view_review_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.ACTION_VIEW_REVIEW_DETAILS
  ),
};

export const AppraisalLandingMap = {
  ...AppraisalMap,
  ...map,
};
